// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-gatsby-theme-andy-src-templates-note-js": () => import("./../../../node_modules/gatsby-theme-andy/src/templates/note.js" /* webpackChunkName: "component---node-modules-gatsby-theme-andy-src-templates-note-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

